<template>
  <MarketingSocialsSocialShare class="bg-layer-secondary py-4" in-modal>
    <template #title>
      <p class="text-base-priority w-full text-center">
        {{ $t('share-this-game-with-friends') }}
      </p>
    </template>
  </MarketingSocialsSocialShare>
</template>
